import { MenuItem } from "../models/menu-item";
import { Routing } from "../routes/app-routes";

export const dashboardTabs: MenuItem[] = [
    {
      name: 'dashboard',
      link: `${Routing.dashboardTab}`,
      icon: null,
      image: null,
      children: null,
    },
    {
      name: 'supervisorboard',
      link: Routing.superVisorBoard,
      icon: null,
      image: null,
      children: null,
    },
    {
      name: 'honorboard',
      link: Routing.honorTab,
      icon: null,
      image: null,
      children: null,
    }
  ];